<template>
  <footer class="modal-footer">
    <button
      :disabled="disableButtons"
      type="button"
      class="btn btn-info"
      :class="{'with-spinner-btn': loading}"
      @click="$emit('save')"
    >
      {{submitText}}
    </button>
    <button
      :disabled="disableButtons"
      type="button"
      class="btn btn-secondary"
      @click="$emit('cancel')"
    >
      Cancel
    </button>
  </footer>
</template>

<script>
export default {
  name: 'modal-buttons',
  props: {
    disableButtons: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    submitButtonText: {
      type: String,
      default: 'Save',
    },
  },
  computed: {
    submitText() {
      return this.loading ? 'Processing data' : this.submitButtonText;
    },
  },
};
</script>
<style scoped>
.spinner-wrap {
  display: inline-block;
}

.with-spinner-btn {
  position: relative;
  padding-left: 32px;
}

.with-spinner-btn:before {
  position: absolute;
  left: 10px;
  top: 8px;
  display: inline-block;
  content: '';
  width: 16px;
  height: 16px;
  margin: 0 auto;
  border: 2px solid white;
  border-radius: 50%;
  border-left-color: transparent;
  border-right-color: transparent;
  animation: cssload-spin 575ms infinite linear;
  -o-animation: cssload-spin 575ms infinite linear;
  -ms-animation: cssload-spin 575ms infinite linear;
  -webkit-animation: cssload-spin 575ms infinite linear;
  -moz-animation: cssload-spin 575ms infinite linear;
}

@keyframes cssload-spin {
  100% {
    transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-o-keyframes cssload-spin {
  100% {
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-ms-keyframes cssload-spin {
  100% {
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-webkit-keyframes cssload-spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-moz-keyframes cssload-spin {
  100% {
    -moz-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ModalButtons.vue